import { ref } from 'vue';

import CaptainAssistantAPI from 'dashboard/api/captain/assistant';

const emptyMeta = () => ({
  total_count: 0,
  page: 1,
  per_page: 10,
  total_pages: 0,
});

export const useAgentPromptVersions = ({ assistantId, enabled, t }) => {
  const versions = ref([]);
  const meta = ref(emptyMeta());
  const isLoading = ref(false);
  const error = ref('');
  let requestId = 0;

  const reset = () => {
    requestId += 1;
    versions.value = [];
    meta.value = emptyMeta();
    error.value = '';
    isLoading.value = false;
  };

  const fetchVersions = async ({ page = 1 } = {}) => {
    const targetAssistantId = Number(assistantId.value || 0);
    if (!targetAssistantId || !enabled.value) {
      reset();
      return [];
    }

    requestId += 1;
    const currentRequestId = requestId;
    isLoading.value = true;
    error.value = '';
    try {
      const { data } = await CaptainAssistantAPI.promptVersions({
        assistantId: targetAssistantId,
        sourceType: 'assistant',
        page,
        perPage: 10,
      });
      if (
        currentRequestId !== requestId ||
        targetAssistantId !== Number(assistantId.value || 0)
      ) {
        return data.payload || [];
      }

      versions.value = data.payload || [];
      meta.value = { ...emptyMeta(), ...data.meta };
      return versions.value;
    } catch (fetchError) {
      if (currentRequestId === requestId) {
        error.value =
          fetchError?.message ||
          t('CAPTAIN_EXPERIENCE.WORKSPACE.VERSION_HISTORY_ERROR');
      }
      return [];
    } finally {
      if (currentRequestId === requestId) isLoading.value = false;
    }
  };

  return { versions, meta, isLoading, error, fetchVersions, reset };
};
